// 'use server'

import { getInfoCustomer, LOGIN_SOCIAL_GOOGLE, SIGNIN } from '@/features/auth/services'
import { getReferralDataForAuth, clearStoredReferralData } from '@/features/save-log'

import yup from '@/utils/yup-global'
import { loginSchema } from '@/validations'

import { getRefCookies, setCookies } from '@/libs/cookies'
import fetcher from '@/services/fetcher'

export const LoginAction = async (values: yup.InferType<typeof loginSchema>, callbackUrl?: string | null) => {
  let token
  try {
    // Lấy referral tracking data từ localStorage (nếu có)
    const referralData = getReferralDataForAuth()

    const variables: any = {
      email: values?.email,
      password: values?.password,
    }

    // Thêm referral data vào variables nếu có
    if (referralData) {
      Object.assign(variables, {
        meta_log: JSON.stringify(referralData),
        referral_source: referralData.referral_source || undefined,
        target_url: referralData.target_url || undefined,
        camp: referralData.camp || undefined,
        adsid: referralData.adsid || undefined,
        platform: referralData.platform || undefined,
        referral_type: referralData.referral_type || undefined,
      })
    }

    const response = await fetcher
      .post('', {
        query: SIGNIN,
        variables,
      })
      .then((res) => {
        return res?.payload
      })
    const tempToken = response?.data?.generateCustomerToken?.token
    if (!tempToken) {
      return {
        status: 'error' as const,
        message: response?.errors?.[0]?.message,
      }
    }
    token = tempToken

    // Clear referral data sau khi login thành công
    if (referralData) {
      clearStoredReferralData()
      console.log('[Login] Cleared referral data after successful login')
    }
  } catch (error: any) {
    console.error('Login action error:', error)
    return {
      status: 'error' as const,
      message: error?.message ?? "something's wrong",
    }
  }
  await setCookies(token)
  const infoUser = (await getInfoCustomer()) as ICustomerInfo
  if (!infoUser) {
    return {
      status: 'error' as const,
      message: 'Failed to get user info',
    }
  }
  // if (infoUser?.increment_id) {
  //   await setRefCookies(infoUser?.increment_id)
  // }
  // Ensure response is serializable
  return {
    status: 'success' as const,
    data: infoUser,
  }
}

type TLoginGoogle = {
  authuser: string
  code: string
  handle: string
  prompt: string
  scope: string
  state: string
  _fbc?: string
  _fbp?: string
  refCode?: string
}

export const loginWithGoogleAction = async (data: TLoginGoogle) => {
  try {
    const refParams = await getRefCookies()

    // Lấy referral tracking data từ localStorage (nếu có)
    const referralData = getReferralDataForAuth()

    const variables: any = {
      authuser: data?.authuser,
      code: data?.code,
      handle: data?.handle,
      prompt: data?.prompt,
      scope: data?.scope,
      state: data?.state,
      signup_method: 'google',
      fbc: data?._fbc ?? undefined,
      fbp: data?._fbp ?? undefined,
      referral_code: data?.refCode ?? undefined,
      new_parent_referral_code: refParams ?? undefined,
    }

    // Thêm referral data nếu có
    if (referralData) {
      Object.assign(variables, {
        meta_log: JSON.stringify(referralData),
        referral_source: referralData.referral_source ?? undefined,
        referral_type: referralData.referral_type ?? undefined,
        target_url: referralData.target_url ?? undefined,
        camp: referralData.camp ?? undefined,
        adsid: referralData.adsid ?? undefined,
        platform: referralData.platform ?? undefined,
        mailing_id: referralData.mailing_id ?? undefined,
      })
    }

    const res = await fetcher.post('', {
      query: LOGIN_SOCIAL_GOOGLE,
      variables,
    })

    const token = res?.payload?.data?.generateCustomerTokenSocialLogin?.token
    console.log('loginWithGoogleAction token:', res)

    if (token) {
      // Clear referral data sau khi login thành công
      if (referralData) {
        clearStoredReferralData()
        console.log('[Google Login] Cleared referral data after successful login')
      }

      return {
        status: 'success' as const,
        data: token,
      }
    } else {
      console.log('Login Google failed:', res?.payload?.errors)
      throw new Error(res?.payload?.errors?.[0]?.message || 'Xảy ra lỗi trong quá trình đăng nhập Google')
    }
  } catch (error: any) {
    console.log('error:', error)
    throw new Error(error)
  }
}
